import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SectionHeaderGapModule } from 'src/app/shared/section-header-gap/section-header-gap.module';
import { ImageTitleModule } from '@studiobuki/web-core/lib/image-title';
import { InputModule } from '@studiobuki/web-core/lib/input';
import { ButtonModule } from '@studiobuki/web-core/lib/button';
import { FormSignInComponent } from './components/form-sign-in/form-sign-in.component';
import { FormSignUpComponent } from './components/form-sign-up/form-sign-up.component';
import { AuthCardComponent } from './components/auth-card/auth-card.component';
import { AuthPageComponent } from './auth-page.component';
import { FormResetComponent } from './components/form-reset/form-reset.component';
import { FormSignUpFinalComponent } from './components/form-sign-up-final/form-sign-up-final.component';

@NgModule({
  declarations: [
    AuthPageComponent,
    AuthCardComponent,
    FormSignInComponent,
    FormSignUpComponent,
    FormResetComponent,
    FormSignUpFinalComponent,
  ],
  imports: [
    CommonModule,
    SectionHeaderGapModule,
    ImageTitleModule,
    InputModule,
    ButtonModule,
  ],
})
export class AuthPageModule {}
